<template>
    <div v-if="product" class="product-details px-0 pt-3 pb-0">
        <v-card class="pa-2" flat tile>
            <v-row>
                <!-- back btn & categories -->
                <v-col cols="12" class="py-0">
                    <div class="d-flex flex-row align-center mb-2">
                        <back-button/>
                        <!--<v-spacer></v-spacer>-->

                        <!--<template v-if="!isFetchingProducts">-->
                        <!--<v-chip v-for="category in product.product_categories"-->
                        <!--:key="category.id"-->
                        <!--small-->
                        <!--color="secondary"-->
                        <!--class="ml-1">-->
                        <!--{{ category.title }}-->
                        <!--</v-chip>-->
                        <!--</template>-->
                        <!--<v-skeleton-loader type="chip" v-else />-->
                    </div>
                </v-col>
                <!-- /back btn & categories -->

                <!-- product image/s -->
                <v-col class="py-0" cols="12" sm="5">
                    <div class="position-relative mb-5" v-if="!isFetchingProducts">
                        <v-carousel pa-0
                                    cycle
                                    height="auto"
                                    hide-delimiters
                                    :show-arrows="false"
                                    v-model="carouselIndex">
                            <v-carousel-item
                                    v-for="(image, i) in product.images.length > 0 ? product.images : [{ source: '//via.placeholder.com/150x150/a1a1a1/FF0000/?text=Fallback' }]"
                                    :key="i">
                                <v-img :src="image.source" aspect-ratio="1">
                                    <card-image-overlay v-if="product.unavailable || !product.active || !product.available_in_country"
                                                        :unavailable="product.unavailable"
                                                        :inactive="!product.active"
                                                        :availableInCountry="product.available_in_country"
                                                        detailView/>
                                </v-img>
                            </v-carousel-item>
                            <div class="v-carousel__controls"
                                 v-if="product.images.length > 1">
                                <v-icon class="mr-3" @click="carouselIndex--" :disabled="!(carouselIndex > 0)">
                                    mdi-chevron-left
                                </v-icon>
                                {{ `${carouselIndex+1}/${product.images.length}` }}
                                <v-icon class="ml-3" @click="carouselIndex++" :disabled="!(carouselIndex < product.images.length - 1)">
                                    mdi-chevron-right
                                </v-icon>
                            </div>
                        </v-carousel>

                        <!--<v-img v-if="product.required_rank"-->
                        <!--class="wishlist-entry-card__rank mt-1 mr-1"-->
                        <!--width="16px"-->
                        <!--:src="product.required_rank.icon"></v-img>-->
                    </div>

                    <v-skeleton-loader type="image@2" tile flat v-else/>
                </v-col>
                <!-- /product image/s -->

                <!-- product content -->
                <v-col class="py-0" cols="12" sm="7">
                    <!-- product info -->
                    <v-row no-gutters>
                        <v-col class="pl-5 pr-3">
                            <div class="body-1 text-uppercase">
                                <template v-if="!isFetchingProducts">{{ product.product_brand }}</template>
                            </div>
                            <h1 class="headline font-weight-bold">
                                <template v-if="!isFetchingProducts">{{ product.title }}</template>
                                <v-skeleton-loader type="heading" class="mb-1" v-else/>
                            </h1>
                            <div class="mt-2 pb-0 body-1">
                                <template v-if="!isFetchingProducts">
                                    {{ $vuetify.lang.t('$vuetify.shop.sku') }} {{ product.sku }}
                                </template>
                                <v-skeleton-loader type="text" class="mb-1" v-else/>
                            </div>
                            <div class="headline font-weight-bold mb-6">
                                <template v-if="!isFetchingProducts">
                                    {{ product.price | number }} {{ $vuetify.lang.t('$vuetify.points.long') }}
                                </template>
                                <v-skeleton-loader type="sentences" v-else/>
                            </div>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn icon
                                   :loading="whileSubmittingWishlist"
                                   :disabled="whileSubmittingWishlist"
                                   @click="toggleWishlistItem"
                                   v-if="!isFetchingProducts && product.active">
                                <v-icon v-if="onWishlist">mdi-heart</v-icon>
                                <v-icon v-else>mdi-heart-outline</v-icon>
                            </v-btn>
                            <v-skeleton-loader type="avatar" v-else-if="isFetchingProducts"/>
                        </v-col>
                    </v-row>
                    <!-- /product info -->

                    <template v-if="shopIsDisabledByTerms">
                            <div class="mb-2 error--text">
                                {{ $vuetify.lang.t('$vuetify.widgets.checkout.disabled_by_terms_hint') }}
                            </div>
                    </template>

                    <!-- add to cart btn -->
                    <template v-if="!product.unavailable && product.active && product.available_in_country">
                        <v-btn @click="addToCart"
                               class="mb-2"
                               color="primary darken-1"
                               block
                               :loading="whileAddingToCart"
                               :disabled="whileAddingToCart">
                            <v-icon left>mdi-cart-outline</v-icon>
                            {{ $vuetify.lang.t('$vuetify.buttons.add_to_cart') }}
                        </v-btn>
                    </template>
                    <v-skeleton-loader type="button" v-else-if="isFetchingProducts" class="d-flex justify-center"/>
                    <!-- /add to cart btn -->

                    <!-- add to wishlist btn -->
                    <template v-if="!isFetchingProducts && product.active">
                        <v-btn v-if="onWishlist"
                               @click="toggleWishlistItem"
                               primary
                               block
                               class="btn-ghost"
                               outlined
                               color="white"
                               :loading="whileSubmittingWishlist"
                               :disabled="whileSubmittingWishlist">
                            <v-icon left>mdi-heart</v-icon>
                            {{ $vuetify.lang.t('$vuetify.buttons.remove_from_wishlist') }}
                        </v-btn>
                        <v-btn v-else
                               @click="toggleWishlistItem"
                               primary
                               block
                               class="btn-ghost"
                               outlined
                               color="white"
                               :loading="whileSubmittingWishlist"
                               :disabled="whileSubmittingWishlist">
                            <v-icon left>mdi-heart-outline</v-icon>
                            {{ $vuetify.lang.t('$vuetify.buttons.add_to_wishlist') }}
                        </v-btn>
                    </template>
                    <v-skeleton-loader type="button" v-else-if="isFetchingProducts" class="d-flex justify-center"/>
                    <!-- /add to wishlist btn -->

                    <!-- product details -->
                    <div class="px-5 mt-6">
                        <anchor-content :content="product.details" v-if="!isFetchingProducts"/>
                        <template v-else>
                            <v-skeleton-loader type="paragraph@3" class="mb-2"/>
                            <v-skeleton-loader type="sentences@3"/>
                            <v-skeleton-loader type="paragraph@3" class="mb-2"/>
                            <v-skeleton-loader type="sentences@3"/>
                        </template>
                    </div>
                    <!-- /product details -->
                </v-col>
                <!-- /product content -->
            </v-row>
        </v-card>

        <!-- related products -->
        <div class="mt-5" v-if="product.related.length > 0">
            <heading-section :loading="isFetchingProducts" class="d-flex">
                {{ $vuetify.lang.t('$vuetify.shop.related_products_title') }}
            </heading-section>

            <v-row no-gutters class="mx-n1">
                <v-col
                        class="px-1 mb-2"
                        cols="6" sm="4" md="3"
                        :key="relatedProduct.id"
                        v-for="relatedProduct in product.related">

                    <template v-if="!isFetchingProducts">
                        <product-card :product="relatedProduct"></product-card>
                    </template>

                    <!-- skeleton loading -->
                    <v-card flat tile class="pa-2 fill-height d-flex flex-column" v-else>
                        <v-skeleton-loader type="image" class="mb-5" tile/>
                        <v-skeleton-loader type="heading" class="mb-2"/>
                        <v-skeleton-loader type="sentences"/>
                    </v-card>
                    <!-- /skeleton loading -->

                </v-col>
            </v-row>
        </div>
        <!-- /related products -->

        <!-- random related products by category -->
        <div class="mt-5" v-if="productsByCategory.length > 0">
            <heading-section :loading="isFetchingProducts" class="d-flex">
                {{ $vuetify.lang.t('$vuetify.shop.related_products_category_title') }}
            </heading-section>

            <v-row no-gutters class="mx-n1">
                <v-col
                        class="px-1 mb-2"
                        cols="6" sm="4" md="3"
                        :key="product.id"
                        v-for="product in productsByCategory">

                    <template v-if="!isFetchingProducts">
                        <product-card :product="product"></product-card>
                    </template>

                    <!-- skeleton loading -->
                    <v-card flat tile class="pa-2 fill-height d-flex flex-column" v-else>
                        <v-skeleton-loader type="image" class="mb-5" tile/>
                        <v-skeleton-loader type="heading" class="mb-2"/>
                        <v-skeleton-loader type="sentences"/>
                    </v-card>
                    <!-- /skeleton loading -->

                </v-col>
            </v-row>
        </div>
        <!-- /random related products by category -->

    </div>

    <!-- page error -->
    <v-container v-else>
        <page-not-found/>
    </v-container>
    <!-- /page error -->
</template>

<script>
    // 3rd
    import {mapActions, mapState} from 'vuex';
    // components
    import AnchorContent from '../../components/AnchorContent';
    import BackButton from '../../components/BackButton';
    import HeadingSection from '../../components/HeadingSection';
    import PageNotFound from '../../components/PageNotFound';
    import ProductCard from '../../components/Cards/Product';
    import CardImageOverlay from '../../components/CardImageOverlay';
    // models
    import Cart from '../../models/Cart';
    import Product from '../../models/Product';
    import WishlistEntry from '../../models/WishlistEntry';
    // utils
    import {
        LOADER_ADD_CART,
        LOADER_FETCH_PRODUCTS,
        LOADER_SUBMIT_WISHLIST,
        ROUTE_CART,
    } from '../../utils/constants';
    import { setPageTitle } from '../../utils/helper';

    export default {
        name: 'product',
        components: {
            AnchorContent,
            BackButton,
            HeadingSection,
            PageNotFound,
            ProductCard,
            CardImageOverlay,
        },
        props: ['productId'],
        data() {
            return {
                carouselIndex: 0,
            }
        },
        computed: {
            ...mapState(['shopIsDisabledByTerms']),
            product() {
                return Product.query().withAll().find(this.productId);
            },
            onWishlist() {
                return WishlistEntry.query().where('product_id', Number(this.productId)).get().length > 0;
            },
            whileAddingToCart() {
                return this.$wait.is(LOADER_ADD_CART);
            },
            whileSubmittingWishlist() {
                return this.$wait.is(LOADER_SUBMIT_WISHLIST);
            },
            items() {
                return WishlistEntry.all();
            },
            notFoundTitle() {
                return this.$vuetify.lang.t('$vuetify.page_not_found.page_title');
            },
            isFetchingProducts() {
                return this.$wait.is(LOADER_FETCH_PRODUCTS);
            },
            productsByCategory() {
                return this.product && Product.getRandomByCategory(this.product);
            },
        },
        methods: {
            ...mapActions([
                'setSnackbar',
            ]),
            async toggleWishlistItem() {
                if (this.onWishlist) {
                    await WishlistEntry.remove(this.productId);
                } else {
                    await WishlistEntry.add(this.productId);
                }
            },
            async addToCart() {
                await Cart.add({
                    product_id: this.productId,
                });

                this.setSnackbar({
                    image: this.product.images[0].source,
                    positionY: 'top',
                    button: {
                        text: this.$vuetify.lang.t('$vuetify.buttons.to_cart'),
                        to: { name: ROUTE_CART },
                    },
                    type: 'success',
                    text: 'added_to_cart',
                    time: 5000,
                });
            },
        },
        async mounted() {
            await Product.fetch();
        },
    }
</script>
